// Public commons (street, Game Hall floors, driving school, car dealer, bike shop) are canned-palette only — mirrors
// CANNED_ONLY_ROOMS in backend ws.py (free text there is dropped server-side). Phaser-free for `node --test`.
export const CANNED_ONLY_ROOMS = new Set(['town', 'game_hall:down', 'game_hall:up', 'driving_school', 'car_dealer', 'bike_shop']);
